import InvoiceEmailAPI from "@/clients/invoice/invoiceEmail"

class InvoiceEmailService {

    async sendInvoiceEmail(token, params) {
        await InvoiceEmailAPI.post(token, params)
    }
}

export const invoiceEmailService = new InvoiceEmailService()